module.exports = __webpack_public_path__ + "img/IoTServe1_1.fe5dc761.png";